import { TokenExIframeStyles } from "@insite/client-framework/Common/Hooks/useTokenExFrame";
import { WIDGETS } from "@tSurya/theme/design";

export const hostedPaymentFieldTokens = (WIDGETS as any).checkoutPaymentInformation.hostedPaymentField;

export const getHostedPaymentTokenExFrameStyleConfig = (
    tokenExFrameStyleConfig: TokenExIframeStyles | undefined,
): TokenExIframeStyles => {
    const baseOverrides = `height: ${hostedPaymentFieldTokens.height}; width: calc(100% - ${hostedPaymentFieldTokens.inlineEndInset});${
        hostedPaymentFieldTokens.padding ? ` padding: ${hostedPaymentFieldTokens.padding};` : ""
    }`;
    const stateOverrides = hostedPaymentFieldTokens.stateBorderWidth
        ? ` border-width: ${hostedPaymentFieldTokens.stateBorderWidth}; padding: ${hostedPaymentFieldTokens.padding};`
        : "";

    return {
        ...tokenExFrameStyleConfig,
        base: `${tokenExFrameStyleConfig?.base ?? ""} ${baseOverrides}`,
        focus: `${tokenExFrameStyleConfig?.focus ?? ""}${stateOverrides}`,
        error: `${tokenExFrameStyleConfig?.error ?? ""}${stateOverrides}`,
        cvv: {
            ...tokenExFrameStyleConfig?.cvv,
            base: `${tokenExFrameStyleConfig?.cvv?.base ?? tokenExFrameStyleConfig?.base ?? ""} ${baseOverrides}`,
            focus: `${tokenExFrameStyleConfig?.cvv?.focus ?? tokenExFrameStyleConfig?.focus ?? ""}${stateOverrides}`,
            error: `${tokenExFrameStyleConfig?.cvv?.error ?? tokenExFrameStyleConfig?.error ?? ""}${stateOverrides}`,
        },
    };
};